import { currencyTypeEnum, virtualPosEnum, subProductEnum, presentialPosEnum } from "../enums";
import { mapToVirtualValue } from "~/mappers";
import * as moment from "moment";
import { isEmpty } from './Utils';

export var newMapRequestGenerateCommerceCodeMultiAdress = function newMapRequestGenerateCommerceCodeMultiAdress(_ref) {
  var state = _ref.state,
      commercialTariffResult = _ref.commercialTariffResult,
      isNotBimoney = _ref.isNotBimoney,
      isVirtual = _ref.isVirtual,
      isPresential = _ref.isPresential,
      user = _ref.user,
      masterData = _ref.masterData,
      isMulti = _ref.isMulti,
      requestModalityBimoneda = _ref.requestModalityBimoneda,
      idTransactionBimoneda = _ref.idTransactionBimoneda,
      indiceMultiAdrees = _ref.indiceMultiAdrees;
  var channelName = user.channelName,
      subChannelName = user.subChannelName,
      groupChannelName = user.groupChannelName,
      username = user.username;
  //Set date

  var fechaActual = new Date();
  fechaActual.setDate(fechaActual.getDate() + 2);
  var year = fechaActual.getUTCFullYear();
  var month = fechaActual.getUTCMonth() + 1;
  var day = fechaActual.getUTCDate();
  month = month < 10 ? '0' + month : month;
  day = day < 10 ? '0' + day : day;
  var fechaFormateada = year + '-' + month + '-' + day + 'T00:00:00.0000000Z';
  //
  var mcci = commercialTariffResult.mcci,
      mccn = commercialTariffResult.mccn,
      mccnName = commercialTariffResult.mccnName,
      currency = commercialTariffResult.currency,
      paymentData = commercialTariffResult.paymentData,
      debitCommission = commercialTariffResult.debitCommission,
      creditCommission = commercialTariffResult.creditCommission;
  var idTransaction = state.idTransaction,
      validateCrmClientData = state.validateCrmClientData,
      rucValidation = state.rucValidation,
      osvType = state.osvType,
      businessSchedule = state.businessSchedule,
      legalRepresentativeData = state.legalRepresentativeData,
      virtual = state.virtual,
      installationSchedule = state.installationSchedule,
      posSelected = state.posSelected,
      afilliationSummary = state.afilliationSummary,
      modalityType = state.modalityType,
      comission = state.comission,
      currencyTypeBimoneda = state.currencyTypeBimoneda,
      commerceCodePadre = state.commerceCodePadre,
      inMultiAdressisSameDirection = state.inMultiAdressisSameDirection,
      corresponsaliaData = state.corresponsaliaData;
  var comisionesMarca = comission.comisionesMarca;
  var _state$businessData = state.businessData,
      commerceData = _state$businessData.commerceData,
      commercialAddress = _state$businessData.commercialAddress,
      administrativeAddress = _state$businessData.administrativeAddress,
      refData = _state$businessData.refData;
  var ruc = rucValidation.ruc,
      businessName = rucValidation.businessName;
  var pos = posSelected.pos,
      TipoConexion = posSelected.TipoConexion;


  creditCommission = creditCommission || 3.99;
  debitCommission = debitCommission || 2.99;

  if (businessSchedule.schedule) {
    businessSchedule.schedule[0] = businessSchedule.schedule[0] == 0 ? true : false;
    businessSchedule.schedule[1] = businessSchedule.schedule[1] == 1 ? true : false;
    businessSchedule.schedule[2] = businessSchedule.schedule[2] == 2 ? true : false;
    businessSchedule.schedule[3] = businessSchedule.schedule[3] == 3 ? true : false;
    businessSchedule.schedule[4] = businessSchedule.schedule[4] == 4 ? true : false;
    businessSchedule.schedule[5] = businessSchedule.schedule[5] == 5 ? true : false;
    businessSchedule.schedule[6] = businessSchedule.schedule[6] == 6 ? true : false;
  }

  var dataAdministrativa = inMultiAdressisSameDirection == true ? state.multiAdress[0] : administrativeAddress;
  var developer = pos == virtualPosEnum.PAGO_WEB ? virtual.webSite.developer : virtual.app.developer;
  var integration = pos == virtualPosEnum.PAGO_WEB ? virtual.webSite.integration : virtual.app.integration;

  var subReason = void 0,
      reason = void 0,
      subProductCode = void 0,
      equipmentType = void 0,
      idTradePlan = "",
      isMulticommerce = false;

  switch (Number(state.osvType.osvType)) {
    // individual
    case 1:
      reason = isNotBimoney ? "INS" : "INS_MLT";
      subReason = isNotBimoney ? "INS_0" : "INS_MLT";
      break;
    // multicomercio
    case 2:
      reason = "INS";
      subReason = "INS_MLT";
      isMulticommerce = true;
      mccn = "0100";
      break;
    // código hijo
    case 3:
      reason = "RGS";
      subReason = "RGS_0";
      mccn = "0100";
      break;
  }

  if (isVirtual) {
    idTradePlan = "CE";
    switch (pos) {
      case virtualPosEnum.PAGO_APP:
        subProductCode = subProductEnum.PAGO_APP;
        idTradePlan += "APP0000" + (currency === currencyTypeEnum.SOLES ? "3" : "4");
        break;
      case virtualPosEnum.PAGO_LINK:
        subProductCode = subProductEnum.PAGO_LINK;
        idTradePlan += "PAGLIK0" + (currency === currencyTypeEnum.SOLES ? "7" : "8");
        break;
      case virtualPosEnum.PAGO_WEB:
        subProductCode = subProductEnum.PAGO_WEB;
        idTradePlan += "PAGOWB0" + (currency === currencyTypeEnum.SOLES ? "5" : "6");
        break;
    }
  } else subProductCode = "BP";

  switch (TipoConexion) {
    case "RTC":
      equipmentType = "DPA";
      break;
    case "IPC":
      equipmentType = "PIP";
      break;
    case "CEL":
      equipmentType = "CLX";
      break;
    default:
      equipmentType = "";
  }

  var LegalBirthDate = moment(legalRepresentativeData.birthdate).format("YYYY-MM-DD");
  var equipmentQuantity = 0;

  if (state.afilliationSummary.equipment) {
    equipmentQuantity = parseInt(state.afilliationSummary.equipment.value, 10);
    if (isNaN(equipmentQuantity)) equipmentQuantity = 1;
  }

  // CAMBIO: Documento Funcional Necomplus Partner de Red 2.0
  var providerUsername = "";
  switch (groupChannelName) {
    case "DEALER NECOMPLUS PDR":
      providerUsername = "NPLPDR"; //antes: 'NPL PDR'
      break;
    case "DEALER NECOMPLUS LIMA":
    case "DEALER NECOMPLUS PROVINCIA":
      providerUsername = "NPLPDC"; //antes: 'NPL'
      break;
    default:
      providerUsername = "SCRPDC"; //antes: 'VNT'
  }

  var paymentMethod = "";
  switch (afilliationSummary.posName) {
    case "Pago Link":
      paymentMethod = "MP01";
      break;
    case "Telepago":
      paymentMethod = "MP02";
      break;
    case "Pago App":
      paymentMethod = "MP02";
      break;
    case "Pago Web":
      paymentMethod = "MP03";
      break;
  }

  var request = {
    audit: {
      appId: "PCRM001V1",
      usuario: username, // null
      ipServidor: undefined, // setea servicio
      transaccionId: idTransactionBimoneda ? idTransactionBimoneda : idTransaction,
      origen: undefined // setea servicio (clientAppName)
    },
    //afiliarComercioRequest
    cliente: {
      ruc: ruc,
      razonSocial: businessName,
      razonSocialAbreviado: commerceData.tradeName, // null
      nombreComercial: commerceData.tradeName, // null
      tipo: "N",
      ttoDatosPersonales: afilliationSummary.authorizePersonalDataTreatment,
      proveedorCampo: providerUsername,
      habilitadoSunat: "01",
      fechaConsultaSunat: rucValidation.consultDate,
      estaListasNegras: false,
      estaGesintelPLAFT: "01",
      actEconomica: validateCrmClientData && (validateCrmClientData.SIC + " - " + validateCrmClientData.Desc).trim(),
      segmento: "D",
      correoDAE: commerceData.email.toLowerCase(), // null
      canal: channelName,
      subCanal: subChannelName,
      grupoCanal: groupChannelName
    },
    comisiones: {
      comisionCreditoOtraPlataforma: comission.comisionCreditoOtraPlataforma,
      comisionDebitoOtraPlataforma: comission.comisionDebitoOtraPlataforma
    },
    comisionesMarca: comisionesMarca,

    contactos: {
      tipo: "01",
      nombres: legalRepresentativeData.firstName,
      primerApellido: legalRepresentativeData.paternalName,
      segundoApellido: legalRepresentativeData.maternalName,
      tipoDocumento: mapToVirtualValue("tipoDocumento", legalRepresentativeData.documentType.Code),
      numeroDocumento: legalRepresentativeData.documentNumber,
      cargo: "Z002",
      telefonoFijo: legalRepresentativeData.secondPhone,
      telefonoMovil: legalRepresentativeData.cellPhone,
      correo: legalRepresentativeData.email.toLowerCase(), // null
      fechaNacimiento: LegalBirthDate,
      fechaConsultaSunat: legalRepresentativeData.consultDate,
      estaListasNegras: false,
      nacionalidad: "Peruana", // null
      canal: channelName,
      subCanal: subChannelName,
      grupoCanal: groupChannelName
    },
    direccionAdministrativa: {
      tipo: "A",
      tipoVia: (dataAdministrativa.typeOfRoad || { Code: "" }).Code,
      nombreVia: dataAdministrativa.nameOfRoad,
      numeroVia: dataAdministrativa.numberOfRoad,
      departamento: dataAdministrativa.department.UbiDep,
      descDepartamento: dataAdministrativa.department.Name,
      provincia: dataAdministrativa.province.UbiPro,
      descProvincia: dataAdministrativa.province.Name,
      distrito: dataAdministrativa.district.UbiDis,
      descDistrito: dataAdministrativa.district.Name,
      referencia: inMultiAdressisSameDirection ? commercialAddress.reference : administrativeAddress.reference,
      mz: !isEmpty(dataAdministrativa.block) ? dataAdministrativa.block : undefined, // null
      tipoHabilitacionUrbana: !isEmpty(administrativeAddress[inMultiAdressisSameDirection ? 'tmpTypeUrbanHabilitation' : 'typeUrbanHabilitation'] ? administrativeAddress[inMultiAdressisSameDirection ? 'tmpTypeUrbanHabilitation' : 'typeUrbanHabilitation'].Code : undefined) ? administrativeAddress[inMultiAdressisSameDirection ? 'tmpTypeUrbanHabilitation' : 'typeUrbanHabilitation'] ? administrativeAddress[inMultiAdressisSameDirection ? 'tmpTypeUrbanHabilitation' : 'typeUrbanHabilitation'].Code : undefined : undefined, // null
      habilitacionUrbana: !isEmpty(dataAdministrativa.urbanHabilitation) ? dataAdministrativa.urbanHabilitation : undefined, // null
      lote: !isEmpty(dataAdministrativa.allotment) ? dataAdministrativa.allotment : undefined, // null
      km: !isEmpty(dataAdministrativa.km ? Number(dataAdministrativa.km) : undefined) ? dataAdministrativa.km ? Number(dataAdministrativa.km) : undefined : undefined, // null
      tipoInterior: !isEmpty(dataAdministrativa.interiorType ? dataAdministrativa.interiorType.Code : undefined) ? dataAdministrativa.interiorType ? dataAdministrativa.interiorType.Code : undefined : undefined, // null
      interior: !isEmpty(dataAdministrativa.interior) ? dataAdministrativa.interior : undefined, // null
      tipoConglomerado: "BLK", // null
      conglomerado: "1", // null
      telefono1: inMultiAdressisSameDirection ? commercialAddress.cellPhone : administrativeAddress.cellPhone,
      telefono2: inMultiAdressisSameDirection ? dataAdministrativa.department.TelephonePrefix + commercialAddress.landline : administrativeAddress.prefix + administrativeAddress.landline // null
    },
    direccionComercial: {
      tipo: "C",
      tipoVia: (state.multiAdress[indiceMultiAdrees].typeOfRoad || { Code: "" }).Code,
      nombreVia: state.multiAdress[indiceMultiAdrees].nameOfRoad,
      numeroVia: state.multiAdress[indiceMultiAdrees].numberOfRoad,
      departamento: state.multiAdress[indiceMultiAdrees].department.UbiDep,
      descDepartamento: state.multiAdress[indiceMultiAdrees].department.Name,
      provincia: state.multiAdress[indiceMultiAdrees].province.UbiPro,
      descProvincia: state.multiAdress[indiceMultiAdrees].province.Name,
      distrito: state.multiAdress[indiceMultiAdrees].district.UbiDis,
      descDistrito: state.multiAdress[indiceMultiAdrees].district.Name,
      referencia: commercialAddress.reference,
      mz: !isEmpty(state.multiAdress[indiceMultiAdrees].block) ? state.multiAdress[indiceMultiAdrees].block : undefined, // null
      tipoHabilitacionUrbana: !isEmpty(state.multiAdress[indiceMultiAdrees].tmpTypeUrbanHabilitation ? state.multiAdress[indiceMultiAdrees].tmpTypeUrbanHabilitation.Code : undefined) ? state.multiAdress[indiceMultiAdrees].tmpTypeUrbanHabilitation ? state.multiAdress[indiceMultiAdrees].tmpTypeUrbanHabilitation.Code : undefined : undefined, // null
      habilitacionUrbana: !isEmpty(state.multiAdress[indiceMultiAdrees].urbanHabilitation) ? state.multiAdress[indiceMultiAdrees].urbanHabilitation : undefined, // null
      lote: !isEmpty(state.multiAdress[indiceMultiAdrees].allotment) ? state.multiAdress[indiceMultiAdrees].allotment : undefined, // null
      km: !isEmpty(state.multiAdress[indiceMultiAdrees].km ? Number(state.multiAdress[indiceMultiAdrees].km) : undefined) ? state.multiAdress[indiceMultiAdrees].km ? Number(state.multiAdress[indiceMultiAdrees].km) : undefined : undefined, // null
      tipoInterior: !isEmpty(state.multiAdress[indiceMultiAdrees].interiorType ? state.multiAdress[indiceMultiAdrees].interiorType.Code : undefined) ? state.multiAdress[indiceMultiAdrees].interiorType ? state.multiAdress[indiceMultiAdrees].interiorType.Code : undefined : undefined, // null
      interior: !isEmpty(state.multiAdress[indiceMultiAdrees].interior) ? state.multiAdress[indiceMultiAdrees].interior : undefined, // null
      tipoConglomerado: "BLK", // null
      conglomerado: "1", // null
      telefono1: commercialAddress.cellPhone,
      telefono2: state.multiAdress[indiceMultiAdrees].department.TelephonePrefix + commercialAddress.landline // null
    },
    horariosAtencion: isPresential ? {
      lunes: businessSchedule.schedule[0], // null
      martes: businessSchedule.schedule[1], // null
      miercoles: businessSchedule.schedule[2], // null
      jueves: businessSchedule.schedule[3], // null
      viernes: businessSchedule.schedule[4], // null
      sabado: businessSchedule.schedule[5], // null
      domingo: businessSchedule.schedule[6] // null
    } : {
      lunes: false, // null
      martes: false, // null
      miercoles: false, // null
      jueves: false, // null
      viernes: false, // null
      sabado: false, // null
      domingo: false // null
    },
    horasAtencion: {
      horaInicio: undefined, // null
      horaFin: undefined // null
    },
    oportunidad: {
      codComercioPadre: commerceCodePadre ? commerceCodePadre : undefined, // null
      nombreComercial: commerceData.tradeName,
      correo: commerceData.email.toLowerCase(),
      proveedorCampo: providerUsername,
      entidadFinanciera: paymentData.bankName,
      tipoCuenta: paymentData.accountType,
      numeroCuenta: paymentData.accountNumber,
      nroCuentaFormateada: paymentData.alternativeAccountNumber,
      mccInternacional: commerceData.commercialBusiness.Code.trim(),
      descMCCInternacional: commerceData.commercialBusiness.Description.trim(),
      mccNacional: isPresential ? modalityType.oportunidad.mccNacional.trim() : commerceData.commercialBusiness.Code.trim(),
      descMCCNacional: modalityType.oportunidad.descMCCNacional ? modalityType.oportunidad.descMCCNacional : "AFILIACIONES TARIFA 2010",
      comisionCredito: 3.45,
      comisionDebito: 3.45,
      moneda: currency === currencyTypeEnum.DOLARES ? "DOL" : "SOL",
      producto: isVirtual ? "CE" : modalityType.oportunidad.producto,
      subProducto: isVirtual ? subProductCode : modalityType.oportunidad.subProducto,
      tipoAfiliacion: isVirtual ? "01" : modalityType.oportunidad.tipoAfiliacion,
      codigoEjecutivo: undefined, // null
      nombreEjecutivo: undefined, // undefined
      tipoDocumentoEjectivo: undefined, // undefined
      nroDocumentoEjecutivo: undefined, // undefined
      telefonoEjecutivo: undefined, // undefined
      correoEjecutivo: undefined, // undefined
      nombreSupervisor: undefined, // undefined
      fechaInicioVigencia: undefined, // undefined
      fechaFinVigencia: undefined, // undefined
      codPlanComercio: idTradePlan || undefined, // null
      observadoRyC: false,
      estaGesintelPEIRUC: refData[0].AcceptReqd === "false" ? false : true,
      estaGesintelPEPRUC: refData[1].AcceptReqd === "false" ? false : true,
      estaGesintelPEIRL: refData[2].AcceptReqd === "false" ? false : true,
      estaGesintelPEPRL: refData[3].AcceptReqd === "false" ? false : true,
      estaGesintelPLAFTRUC: refData[6].AcceptReqd === "false" ? false : true,
      estaGesintelPLAFTRL: refData[7].AcceptReqd === "false" ? false : true,
      estaListasNegrasTelefonoRL: refData[4].AcceptReqd === "false" ? false : true,
      estaListasNegrasCorreoRL: refData[5].AcceptReqd === "false" ? false : true,
      esMCCRiesgoso: false,
      esMulticomercio: isMulti ? currency === currencyTypeEnum.DOLARES ? false : true : isMulti,
      indicadorRyC1: false,
      indicadorRyC2: false,
      estadoSeguridadRyC: "SO",
      propietario: legalRepresentativeData.firstName ? legalRepresentativeData.firstName.slice(0, 5).trim().split(" ")[0] : undefined, // null
      codPlusDireAdmin: undefined, // undefined
      codPlusDireComer: undefined, // undefined
      codigoBID: undefined, // undefined
      modalidad: isPresential ? modalityType.oportunidad.modalidad : undefined, // undefined
      plan: isPresential ? modalityType.oportunidad.plan : undefined, // undefined
      afiliacion: corresponsaliaData.header.affiliationType && corresponsaliaData.header.affiliationType.CodeAffiliationType ? corresponsaliaData.header.affiliationType.CodeAffiliationType : isPresential ? modalityType.oportunidad.afiliacion : undefined, // undefined
      aceptaTyCContratoAfiiacionWeb: isPresential ? false : true,
      aceptaTyCWeb: isPresential ? false : true,
      permiteDCC: isPresential ? true : false, // undefined
      permiteMultimarca: false, // undefined
      permiteBoletaElectronica: false, // undefined
      segmento: "D",
      marcaVisa: isPresential ? true : undefined, // null
      marcaMC: isPresential ? true : undefined, // null
      marcaAmex: isPresential ? true : undefined, // null
      marcaDiners: isPresential ? true : undefined, // null
      procesadorVisa: isPresential ? "VNT" : undefined, // null
      procesadorMC: isPresential ? "VNT" : undefined, // null
      procesadorAmex: isPresential ? "PMP" : undefined, // null
      procesadorDiners: isPresential ? "PMP" : undefined, // null
      tipoLiquidacionVisa: isPresential ? "TLA" : undefined, // null
      tipoLiquidacionMC: isPresential ? "TLA" : undefined, // null
      tipoLiquidacionAmex: isPresential ? "TLA" : undefined, // null
      tipoLiquidacionDiners: isPresential ? "TLA" : undefined, // null
      tipoComercioVisa: undefined, // null
      tipoComercioMC: undefined, // null
      tipoComercioAmex: undefined, // null
      tipoComercioDiners: isPresential ? "G2" : undefined, // null
      codComercioVisa: undefined, // null
      codComercioMC: undefined, // null
      codComercioDiners: undefined, // null
      codComercioAmexLiqManual: undefined, // null
      codComercioAmexLiqAutomatica: undefined, // null
      canal: channelName,
      subCanal: subChannelName,
      grupoCanal: groupChannelName,
      //Corresponsalia
      tipoDeAgente: corresponsaliaData.header.agent ? corresponsaliaData.header.agent.CodeAgent : undefined,
      cuentaAgente: corresponsaliaData.header.bankAccount ? corresponsaliaData.header.bankAccount : undefined,
      codigoAgenciaMatriz: corresponsaliaData.agentData.codigoAgenciaMatriz,
      oficinaMatriz: corresponsaliaData.agentData.oficinaMatriz,
      tipoOficinaMatriz: corresponsaliaData.agentData.tipoOficinaMatriz,
      ubigeoOficinaMatriz: corresponsaliaData.agentData.ubigeoOficinaMatriz,
      codigoMacroRegion: corresponsaliaData.agentData.codigoMacroRegion,
      macroRegion: corresponsaliaData.agentData.macroRegion,
      area: corresponsaliaData.agentData.area
    },
    datosComercioElectronico: isVirtual ? {
      nombreAdminPMM: virtual.user.fullname || undefined, // null
      correoAdminPMM: virtual.user.email || undefined, // null
      telefonoAdminPMM: virtual.user.phone || undefined, // null
      nombreApp: virtual.app.name || undefined, // null
      datosLinkApp: virtual.app.link || undefined, // null
      // plataformaApp: virtual.app.platform ? (masterData.platform.find(p => p.value === virtual.app.platform) || { text: null }).text : undefined, // null
      plataformaApp: "101" || undefined,
      formularioPago: integration.paymentForm || undefined, // null
      modalidadPosWebTiendaVirtual: afilliationSummary.posName === "Pago Link" ? "102" : undefined, // null
      modalidadUrlDominio: virtual.webSite.url || undefined, // null
      paginaWebWebUrlDominio: virtual.webSite.url || undefined, // null
      desarrollo: (developer.developmentType ? (masterData.development.find(function (p) {
        return p.value === developer.developmentType;
      }) || { text: null }).text : undefined) || undefined, // null
      nombreEmpresa: (developer.company ? developer.company : undefined) || undefined, // null
      nombresDesarrollador: (developer.fullname ? developer.fullname : undefined) || undefined, // undefined
      correoContactoDesarrollador: (developer.email ? developer.email : undefined) || undefined, // undefined
      telefonoContactoDesarrollador: (developer.phone ? developer.phone : undefined) || undefined, // undefined
      posWebTdaVirtualAdapt: afilliationSummary.posName === "Pago Link" ? "102" : undefined // null
    } : undefined,
    datosRecurrentes: undefined,
    ticket: isPresential ? {
      tipoMotivo: "ORD",
      prioridad: "1",
      nombreEncargado: (installationSchedule.name + " " + installationSchedule.paternalLastname).toUpperCase(),
      cargoEncargado: "CONTACTO INSTALACION",
      telefonoFijoEncargado: installationSchedule.phone,
      telefonoMovilEncargado: installationSchedule.phone,
      motivoOrden: requestModalityBimoneda.motivoOrden ? requestModalityBimoneda.motivoOrden : modalityType.ticket.motivoOrden,
      subMotivoOrden: requestModalityBimoneda.subMotivoOrden ? requestModalityBimoneda.subMotivoOrden : modalityType.ticket.subMotivoOrden,
      indHorarioAcordado: true,
      horarioAcordado: pos === presentialPosEnum.POS_FIJO_INTERNET || pos === presentialPosEnum.POS_INALAMBRICO ? fechaFormateada : "2099-01-01T00:00:00.0000000Z", // null
      indHorarioSugerido: true,
      canal: channelName,
      subCanal: subChannelName,
      grupoCanal: groupChannelName,
      esPOSPinpadMpos: state.esPOSPinpadMpos,
      tipoPago: "TP02",
      numeroCuota: 1,
      medioPago: undefined,
      numeroTrxPago: undefined,
      tipoEntrega: "TE02",
      capacitacion: undefined,
      cantidadEquipos: Number(afilliationSummary.equipment.value),
      tipoEquipo: state.tipoEquipo,
      tipoConexion: modalityType.ticket.tipoConexion,
      codComercioPadreMulticomercio: commerceCodePadre ? commerceCodePadre : undefined,
      nombreMulticomercio: undefined,
      tipoVigenciaEquipo: modalityType.ticket.tipoVigenciaEquipo,
      vigenciaEquipoDesde: undefined, // null
      vigenciaEquipoHasta: undefined, // null
      preAutorizacionOSV: false,
      serviciosEquipo: undefined,
      usuarioCreacion: legalRepresentativeData.firstName + " " + legalRepresentativeData.paternalName
    } : undefined,
    ticketDireccionComercio: isPresential ? {
      dirEstandar: state.multiAdress[indiceMultiAdrees].typeOfRoad.Code + " " + state.multiAdress[indiceMultiAdrees].nameOfRoad + " " + state.multiAdress[indiceMultiAdrees].numberOfRoad,
      departamento: state.multiAdress[indiceMultiAdrees].department.UbiDep,
      provincia: state.multiAdress[indiceMultiAdrees].province.UbiPro,
      distrito: state.multiAdress[indiceMultiAdrees].district.UbiDis,
      coordenadaX: undefined, // null
      coordenadaY: undefined // null
    } : undefined,
    ticketHorarioSugerido: isPresential ? {
      lunes: false,
      martes: false,
      miercoles: false,
      jueves: false,
      viernes: false,
      sabado: false,
      domingo: false,
      horaInicio: undefined,
      horaFin: undefined
    } : undefined,
    ticketDireccionRetiroPos: isPresential ? {
      dirEstandar: undefined,
      departamento: undefined,
      provincia: undefined,
      distrito: undefined
    } : undefined,
    ticketOpciones: isPresential ? {
      codOpcion: "OPC", // null
      opcSenalizacion: "043" // null
    } : undefined,
    ticketOperadores: isPresential ? {
      nombres: undefined, // null
      apellidos: undefined, // null
      tipoDocumento: undefined, // null
      numeroDocumento: undefined, // null
      telefono: undefined, // null
      correo1: undefined, // null
      correo2: undefined // null
    } : undefined,
    medioDigital: "HWA"
  };
  return request;
};


//////////////////
// WEBPACK FOOTER
// ./src/mappers/new-generate-commerce-code-multi-adrress.js
// module id = ./src/mappers/new-generate-commerce-code-multi-adrress.js
// module chunks = 34